export default {
  SIAP_INSTITUTION_REPOSITORY: Symbol.for('SIAP_INSTITUTION_REPOSITORY'),
  SEARCH_SIAP_INSTITUTIONS_QUERY: Symbol.for('SEARCH_SIAP_INSTITUTIONS_QUERY'),
};
